<div class="fixed-section">
  <!-- Title Bar Section -->
  <section class="titleBarBg">
    <div class="container-fluid">
      <div class="row mar-7px">
        <div class="w-3">
          <img src="./assets/images/setup_adhoc.png" class="pageIcon" alt="" />
        </div>
        <div class="w-97">
          <div class="pageHeadingBar">
            <div class="row align-items-center">
              <div class="col-md-6 align-self-center">
                <h6 class="pageHeadingText mb-0 text-uppercase">AD HOC</h6>
              </div>
              <div class="col-md-3 align-self-center">
                <div class="d-flex">
                  <div class="nav-item dropdown">
                    <div class="me-1 position-relative actionButton align-self-center dropdown-toggle"
                      (click)="SaveAdHocDetails()" aria-expanded="false">
                      <img src="./assets/images/save_icon.svg" class="saveImg me-2" alt="" title="Save" />
                      <span class="statusValue pe-2">SAVE</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 ms-auto text-end">
                <a (click)="generateAdHocReport()" style="
                    text-decoration: none;
                    cursor: pointer;
                    margin-left: 103px;
                  " title="Export to Excel">
                  <img src="assets/images/export.png" class="w-30" alt=""
                    style="margin-bottom: --5px; margin-right: 10px" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Audit Heading data Section -->
  <section class="mt-131 fixedHeaderBg">
    <div class="container-fluid px-2">
      <div class="row">
        <div class="col-md-12 mt-2">
          <div class="card border-0 stepsBars">
            <div class="card-body pb-1">
              <form #headingData="ngForm">
                <div class="main mx-2 pb-1 ms-0">
                  <div class="d-flex w-100" style="gap: 5px">
                    <div class="col-md-2">
                      <div>
                        <label for="adHocTitle">TITLE <span class="text-danger">*</span></label>
                      </div>
                      <input id="adHocTitle" placeholder="Enter title" class="form-control" name="title"
                        [(ngModel)]="adhocDetails.title" maxlength="200" />
                    </div>
                    <div>
                      <div>
                        <label for="category">CATEGORY <span class="text-danger">*</span></label>
                      </div>
                      <p-multiSelect [options]="categoryList" [(ngModel)]="selectedCategories" name="category"
                        [showHeader]="true" [filter]="true" placeholder="Select Category"
                        (onChange)="onSelectedCategory($event)">
                        <ng-template pTemplate="header">
                          <div class="custom-multiselect-header">
                            <span style="padding-right: 5px">SELECT ALL</span>
                          </div>
                        </ng-template>
                      </p-multiSelect>
                    </div>
                    <div class="col-md-2">
                      <div>
                        <label for="date">DATE <span class="text-danger">*</span></label>
                      </div>
                      <p-calendar dateFormat="dd-MM-yy" placeholder="Select a date" #timePicker name="createdDate"
                        [(ngModel)]="adhocDetails.createdDate">
                      </p-calendar>
                    </div>
                  </div>
                </div>
              </form>

              <!-- Audit Questions Form -->
              <form #auditQuestions="ngForm">
                <div class="row mb-0 pt-40" id="auditquestions">
                  <div style="display: flex; justify-content: space-between; width: 99%;">
                    <h6 class="loginHeadingText text-start pt-1">
                      AUDIT QUESTIONS
                    </h6>
                  </div>
                  <div class="row mb-0" [class.disabled-div]="
                      adhocDetails.title == '' || selectedCategories.length == 0
                    ">
                    <div class="col-md-12 pe-0">
                      <table class="table datatable border-x-0 mb-0">
                        <thead>
                          <tr>
                            <th width="1%"></th>
                            <th width="10%"></th>
                            <th width="17%"></th>
                            <th width="25%"></th>
                            <th width="20%"></th>
                            <th width="10%"></th>
                            <th width="2%"></th>
                          </tr>
                          <tr class="subheaderrr">
                            <th width="1%"></th>
                            <th width="10%">Type <span class="text-danger">*</span></th>
                            <th width="17%">TYPE OF REQUEST <span class="text-danger">*</span></th>
                            <th width="25%">DESCRIPTION <span class="text-danger">*</span></th>
                            <th width="20%">RESPONSE OPTIONS <span class="text-danger">*</span></th>
                            <th width="10%">IMAGES</th>
                            <th width="2%"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let row of auditQuestionRows; let i = index">
                            <td class="text-center align-middle tdHeaderBg">
                              <img src="./assets/images/plus_icon.svg" alt="add" style="cursor: pointer"
                                (click)="addAuditQuestionRow()" />
                            </td>
                            <td class="text-center align-middle tdHeaderBg">
                              <select class="form-select" [(ngModel)]="row.type" name="type{{ i }}" required>
                                <option value="">Select Type</option>
                                <option *ngFor="let ty of auditByList" [value]="ty.lookupKey">
                                  {{ ty.lookupText }}
                                </option>
                              </select>
                            </td>
                            <td class="tdHeaderBg">
                              <select class="form-select" [(ngModel)]="row.typeOfRequest" name="typeOfRequest{{ i }}"
                                required>
                                <option value="">Select Request Type</option>
                                <option *ngFor="let tr of requestTypeList" [value]="tr.lookupKey">
                                  {{ tr.lookupText }}
                                </option>
                              </select>
                            </td>
                            <td class="tdHeaderBg">
                              <textarea class="form-control" placeholder="Enter the description"
                                [(ngModel)]="row.description" name="description{{ i }}"></textarea>
                            </td>
                            <td class="tdHeaderBg">
                              <div class="d-flex flex-column">
                                <select class="form-select mb-1" [(ngModel)]="row.responseOption"
                                  name="responseOption{{ i }}" required>
                                  <option value="">Select Response options </option>
                                  <option *ngFor="let response of responseOptionList" [value]="response.lookupKey">
                                    {{ response.lookupText }}
                                  </option>
                                </select>

                                <input
                                  *ngIf="row.responseOption === 'OTHER' || row.responseOption === 'YESOTHER' || row.responseOption === 'NOTCOMPLETEDACTIVITY'"
                                  type="text" class="form-control" placeholder="Please specify"
                                  [(ngModel)]="row.comments" name="comments{{ i }}" required />
                              </div>
                            </td>
                            <td class="text-center align-middle tdHeaderBg" style="height: 175px;">
                              <div>
                                <label style="cursor: pointer">
                                  <input type="file" style="display: none" (change)="
                                      uploadQuestionImage($event, i, 'question')
                                    " name="image{{ i }}" multiple accept="image/*" #fileInput />
                                  <img [ngClass]="row.image.length == 1 ? 'imgTop' : ''" *ngIf="row.image.length < 2"
                                    src="./assets/images/photo.png" />
                                </label>
                              </div>
                              <div class="flex justify-around items-center mb-3"
                                *ngFor="let img of row.image; let index = index" style="font-size: 10px">
                                <img *ngIf="img.base64String" [src]="getImageSrc(img)" alt="Base64 Image"
                                  style="width:40px;height:40px" />
                                <a (click)="deleteAuditQuestionImage(i, index)">
                                  <i class="fa-solid fa-xmark text-danger mb-2 removeImg"></i>
                                </a>
                              </div>
                              <span class="two-mb">Upload image upto 2 MB</span>
                            </td>
                            <td class="text-center align-middle tdHeaderBg">
                              <ng-container>
                                <img src="./assets/images/close_mark.svg" alt="" (click)="deleteAuditQuestionRow(i)"
                                  *ngIf="this.auditQuestionRows.length > 1" style="cursor: pointer" />
                              </ng-container>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </form>

              <!-- Stocking Priorities Form -->
              <form #stockingForm="ngForm">
                <div class="row mb-0 pt-40" id="stockingpriorities">
                  <h6 class="loginHeadingText text-start pt-1">
                    STOCKING PRIORITIES (ITEMS)
                  </h6>
                  <div class="row mb-0" [class.disabled-div]="
                      adhocDetails.title == '' || selectedCategories.length == 0
                    ">
                    <div class="col-md-12 pe-0">
                      <table class="table datatable border-x-0 mb-0">
                        <thead>
                          <tr class="subheaderrr">
                            <th width="1%"></th>
                            <th width="20%">ITEM NUMBER <span class="text-danger">*</span></th>
                            <th width="20%">UPC <span class="text-danger">*</span></th>
                            <th width="20%">PRODUCT DESCRIPTION <span class="text-danger">*</span></th>
                            <th width="20%">NOTES</th>
                            <th width="10%">IMAGES</th>
                            <th class="border-end-0" width="2%"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="
                              let row of stockingPriorityItemRows;
                              let i = index
                            ">
                            <td class="text-center align-middle tdHeaderBg">
                              <img src="./assets/images/plus_icon.svg" alt="" (click)="addStockingPriorityItemRow()"
                                style="cursor: pointer" />
                            </td>
                            <td class="tdHeaderBg">
                              <p-autoComplete [(ngModel)]="row.itemNumber" (onSelect)="onProductSelect($event, i)"
                                (completeMethod)="filterProducts($event, i)" [suggestions]="filteredProducts"
                                field="productTitle" [inputStyleClass]="'form-control'" [dropdown]="false"
                                name="itemNumber{{ i }}" placeholder="Enter Item Number" [appendTo]="'body'"
                                panelStyleClass="autocomplete-top-panel">
                              </p-autoComplete>
                            </td>
                            <td class="tdHeaderBg text-center align-middle">
                              <p styles="margin-bottom=0px">
                                <strong>{{ row.upc }}</strong>
                              </p>
                            </td>
                            <td class="tdHeaderBg text-center align-middle">
                              <p>{{ row.description }}</p>
                            </td>
                            <td class="tdHeaderBg">
                              <input class="form-control" placeholder="Enter note" [(ngModel)]="row.notes"
                                name="notes{{ i }}" />
                            </td>
                            <td class="text-center align-middle tdHeaderBg">
                              <div>
                                <label style="cursor: pointer">
                                  <input type="file" style="display: none" (change)="
                                      uploadQuestionImage($event, i, 'stocking')" accept="image/*" />
                                  <img src="./assets/images/photo.png" *ngIf="!row.image[0]?.base64String" />
                                </label>
                              </div>
                              <div class="flex justify-around items-center mb-3" style="font-size: 10px"
                                *ngIf="row.image?.[0]?.base64String">
                                <img [src]="getImageSrcForStockingPriorityItem(row.image[0])" alt="Base64 Image"
                                  style="width: 40px; height: 40px" />
                                <img src="./assets/images/close_mark.svg" alt="Remove"
                                  (click)="deleteStockingPriorityItemImage(i)" class="priorityCrossImg"
                                  style="cursor: pointer" />
                              </div>
                              <span class="two-mb">Upload image upto 2 MB</span>
                            </td>
                            <td class="text-center align-middle tdHeaderBg">
                              <ng-container>
                                <img src="./assets/images/close_mark.svg" alt=""
                                  (click)="deleteStockingPriorityItemRow(i)" style="cursor: pointer"
                                  *ngIf="this.stockingPriorityItemRows.length > 1" />
                              </ng-container>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </form>

              <!-- Stocking PrioritY Brands Form -->
              <form #stockingBrandForm="ngForm">
                <div class="row mb-0 pt-40" id="stockingpriorityBrands">
                  <h6 class="loginHeadingText text-start pt-1">
                    STOCKING PRIORITIES (BRANDS)
                  </h6>
                  <div class="row mb-0" [class.disabled-div]="
                      adhocDetails.title == '' || selectedCategories.length == 0
                    ">
                    <div class="col-md-12 pe-0">
                      <table class="table datatable border-x-0 mb-0">
                        <thead>
                          <tr class="subheaderrr">
                            <th width="1%"></th>
                            <th width="20%">BRAND NAME<span class="text-danger">*</span></th>
                            <th width="20%">NOTES</th>
                            <th width="10%">IMAGES</th>
                            <th class="border-end-0" width="2%"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="
                              let row of stockingPriorityBrandRows;
                              let i = index
                            ">
                            <td class="text-center align-middle tdHeaderBg">
                              <img src="./assets/images/plus_icon.svg" alt="" (click)="addStockingPriorityBrandRow()"
                                style="cursor: pointer" />
                            </td>
                            <td class="tdHeaderBg">
                              <input class="form-control" placeholder="Enter Brand Name" [(ngModel)]="row.brandName"
                                name="brandName{{ i }}" />
                            </td>
                            <td class="tdHeaderBg">
                              <input class="form-control" placeholder="Enter note" [(ngModel)]="row.notes"
                                name="notes{{ i }}" />
                            </td>
                            <td class="text-center align-middle tdHeaderBg">
                              <div>
                                <label style="cursor: pointer">
                                  <input type="file" style="display: none" (change)="uploadQuestionImage($event, i, 'stockingbrand')" accept="image/*" />
                                  <img src="./assets/images/photo.png" *ngIf="!row.image[0]?.base64String" />
                                </label>
                              </div>
                              <div class="flex justify-around items-center mb-3" style="font-size: 10px"
                                *ngIf="row.image?.[0]?.base64String">
                                <img [src]="getImageSrcForStockingPriorityItem(row.image[0])" alt="Base64 Image"
                                  style="width: 40px; height: 40px" />
                                <img src="./assets/images/close_mark.svg" alt="Remove"
                                  (click)="deleteStockingPriorityBrandImage(i)" class="priorityCrossImg"
                                  style="cursor: pointer" />
                              </div>
                              <span class="two-mb">Upload image upto 2 MB</span>
                            </td>
                            <td class="text-center align-middle tdHeaderBg">
                              <ng-container>
                                <img src="./assets/images/close_mark.svg" alt=""
                                  (click)="deleteStockingPriorityBrandRow(i)" style="cursor: pointer"
                                  *ngIf="this.stockingPriorityBrandRows.length > 1" />
                              </ng-container>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<p-confirmDialog class="custom-confirm-dialog"></p-confirmDialog>